e4.ecom.productlist = {
    jProductList: jQuery( '.js-e-productlist' ),
    init: function () {
        if ( e4.ecom.productlist.jProductList.length === 1 ) {
            e4.ecom.productlist.filters.init();
        }
    },
    filters: {
        init: function () {
            e4.ecom.productlist.filters.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-e-productlist-filters-group' ).each( function () {
                jQuery( this ).find( '.js-e-productlist-filters-option-reset-group' ).prop( 'checked', false );
                jQuery( '.js-e-productlist-filter', this ).each( function () {
                    if ( jQuery( this ).is( ':checked' ) === false ) {
                        var checkedLength = jQuery( this ).closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filter' ).filter( ':checked' ).length;
                        if ( checkedLength === 0 ) {
                            jQuery( this ).closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filters-option-reset-group' ).prop( 'checked', true );
                        }
                    }
                } );
            } );
            e4.ecom.productlist.jProductList.on( 'change', '.js-e-productlist-filter', function () {
                e4.ecom.productlist.filters.applyFilters( this );
            } );
            // Følgende bør enrettes i navngivning. clear, remove, med eller uden group?
            e4.ecom.productlist.jProductList.on( 'click', '.js-e-productlist-filters-remove', function ( event ) {
                event.preventDefault();
                e4.ecom.productlist.filters.removeFilter( this );
            } );
            jQuery( document ).on( 'click', '.js-e-productlist-filters-clear-all', function ( event ) {
                event.preventDefault();
                e4.ecom.productlist.filters.resetAll();
            } );
            e4.ecom.productlist.jProductList.on( 'change', '.js-e-productlist-filters-option-reset-group', function ( event ) {
                event.preventDefault();
                if ( jQuery( this ).is( ':checked' ) === true ) {
                    e4.ecom.productlist.filters.resetGroup( this );
                }
                else {
                    jQuery( this ).prop( 'checked', true );
                }
            } );
            e4.ecom.productlist.setSort();
        },
        applyFilters: function ( domElm ) {
            var jThis = jQuery( domElm );
            jThis.closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filters-option-reset-group' ).prop( 'checked', false );
            if ( jThis.is( ':checked' ) === false ) {
                var checkedLength = jThis.closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filter' ).filter( ':checked' ).length;
                if ( checkedLength === 0 ) {
                    jThis.closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filters-option-reset-group' ).prop( 'checked', true );
                }
            }
            e4.ecom.productlist.jProductList.find( '.js-e-productlist-form' ).submit();
        },
        removeFilter: function ( domElm ) {
            var strValue = jQuery( domElm ).data( 'value' ),
                strSystemName = jQuery( domElm ).data( 'system-name' );
            e4.ecom.productlist.jProductList.find( '.js-e-productlist-filter[name="' + strSystemName + '"].js-e-productlist-filter[value="' + strValue + '"]' ).prop( 'checked', false );
            e4.ecom.productlist.jProductList.find( '.js-e-productlist-form' ).submit();
        },
        resetGroup: function ( domElm ) {
            jQuery( domElm ).closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filter' ).prop( 'checked', false );
            e4.ecom.productlist.jProductList.find( '.js-e-productlist-form' ).submit();
        },
        resetAll: function () {
            e4.ecom.productlist.jProductList.find( '.js-e-productlist-filter' ).prop( 'checked', false );
            e4.ecom.productlist.jProductList.find( '.js-e-productlist-form' ).submit();
        }
    },
    setSort: function () {
        e4.ecom.productlist.jProductList.on( 'change', '#sortProducts', function () {
            jQuery( 'input[name="SortOrder"]' ).val( jQuery( this ).val() );
            e4.ecom.productlist.jProductList.find( '.js-e-productlist-form' ).submit();
        } );
    },
    setScrollTop: function ( intScrollTop ) {
        var jWindow = jQuery( window );
        if ( intScrollTop < jWindow.scrollTop() ) {
            intScrollTop -= jWindow.height() / 100 * e4.settings.scrollToAnchor.nudge;
            e4.scrollToAnchor.animate( intScrollTop, e4.nav.global.hide );
        }
    }
};
